import { isMobile } from './utils';

import { useRouter } from 'vue-router';
import { computed, onMounted, unref } from 'vue';
export default {
  __name: 'App',
  setup(__props, {
    expose: __expose
  }) {
    __expose();
    const router = useRouter();
    const mode = computed(() => process.env.VUE_APP_MODE);
    onMounted(() => {
      if (isMobile() && unref(mode) === 'prod') {
        router.replace('/mobile');
      }
    });
    const __returned__ = {
      router,
      mode,
      get isMobile() {
        return isMobile;
      }
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
};